<template>
    <b-overlay>
        <div class="row">
            <div v-if="summaryData.motorin.transactionCount > 0" class="col-md-6 mb-1 pr-md-50">
                <div class="stats-group motorin">
                    <h6 class="stats-group-title">Motorin Çıkışları</h6>
                    <div class="row">
                        <div class="col-md-6 col-12">
                            <v-stats-box :value="summaryData.motorin.transactionCount" text="Toplam İşlem" icon="summarize" variant="primary" />
                        </div>
                        <div class="col-md-6 col-12">
                            <v-stats-box :value="summaryData.motorin.totalOutput.toLocaleString('tr-TR')" text="Toplam Çıkış [lt]" icon="local_gas_station" variant="success" />
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="summaryData.adblue.transactionCount > 0" class="col-md-6 mb-1 pl-md-50">
                <div class="stats-group adblue">
                    <h6 class="stats-group-title">AdBlue Çıkışları</h6>
                    <div class="row">
                        <div class="col-md-6 col-12">
                            <v-stats-box :value="summaryData.adblue.transactionCount" text="Toplam İşlem" icon="summarize" variant="primary" />
                        </div>
                        <div class="col-md-6 col-12">
                            <v-stats-box :value="summaryData.adblue.totalOutput.toLocaleString('tr-TR')" text="Toplam Çıkış [lt]" icon="opacity" variant="info" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <b-card no-body>
            <v-table ref="reportTable" :items-provider="fetchDailyReport" :editor="processReportData" :fields="reportFields" :busy.sync="reportLoading" pagination="client" search>
                <template #filters>
                    <div class="row align-items-end mb-0">
                        <div class="col-md-3 col-6 mb-1">
                            <label class="form-label">Başlangıç Tarihi</label>
                            <v-date-picker v-model="reportFilters.startDate" placeholder="Başlangıç" />
                        </div>
                        <div class="col-md-3 col-6 mb-1">
                            <label class="form-label">Bitiş Tarihi</label>
                            <v-date-picker v-model="reportFilters.endDate" placeholder="Bitiş" />
                        </div>
                        <div class="col-md-3 col-12 mb-1">
                            <label class="form-label">Şube</label>
                            <v-select-list v-model="reportFilters.branchIds" :options="branches" label="Name" :reduce="(branch) => branch.Id" placeholder="Tümü" multiple />
                        </div>
                        <div class="col-md-3 col-12 mb-1">
                            <label class="form-label">Yakıt Tipi</label>
                            <v-select-list v-model="reportFilters.fuelTypeIds" :options="fuelTypes" label="VisibleName" :reduce="(fuel) => fuel.Id" placeholder="Tümü" multiple />
                        </div>
                        <div class="col-md-3 col-12 mb-1">
                            <label class="form-label">Araç Plakası</label>
                            <v-select-list v-model="reportFilters.vehiclePlateIds" :options="vehiclePlateOptions" label="PlateValue" :reduce="(plate) => plate.Id" placeholder="Tümü" multiple />
                        </div>
                        <div class="col-md-3 col-12 mb-1">
                            <label class="form-label">Sürücü</label>
                            <v-select-list v-model="reportFilters.driverEmployeeIds" :options="allEmployees" label="FullName" :reduce="(emp) => emp.Id" placeholder="Tümü" multiple />
                        </div>
                        <div class="col-md-6 col-12 mb-1 d-flex justify-content-end align-items-end">
                            <button class="btn btn-outline-secondary ml-1" v-on:click="clearFilters">Temizle</button>
                        </div>
                    </div>
                </template>
                <template #additional-actions>
                    <div class="d-flex justify-content-end">
                        <button v-b-tooltip.hover.bottom title="Dışa Aktar" class="btn btn-sm btn-icon rounded-circle btn-outline-success p-25" v-on:click="exportToExcel" :disabled="reportLoading">
                            <FeatherIcon icon="ArrowDownIcon" size="12" />
                        </button>
                    </div>
                </template>
            </v-table>
        </b-card>
    </b-overlay>
</template>

<script>
import api from "@/api/fuel-storage";
import EmployeeOperationsApi from "@/api/employee-operations";
import VehicleOperationsApi from "@/api/vehicle-operations";
import CompanyApi from "@/api/company";
import SystemDataApi from "@/api/system-data";
import { BCard, BOverlay, VBTooltip } from "bootstrap-vue";
import VStatsBox from "@/components/VStatsBox.vue";
import xlsx from "json-as-xlsx";
import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";

const getInitialFilters = () => ({
    startDate: null,
    endDate: null,
    vehiclePlateIds: [],
    driverEmployeeIds: [],
    storageClassId: null,
    branchIds: [],
    fuelTypeIds: [],
});

export default {
    name: "FuelOutputReportModal",
    components: { BCard, VStatsBox, BOverlay },
    directives: {
        "b-tooltip": VBTooltip,
    },
    data() {
        return {
            summaryData: {
                motorin: {
                    totalOutput: 0,
                    transactionCount: 0,
                },
                adblue: {
                    totalOutput: 0,
                    transactionCount: 0,
                },
            },
            reportFilters: getInitialFilters(),
            reportLoading: false,
            filterWatcher: null,
            allEmployees: [],
            vehiclePlateOptions: [],
            branches: [],
            fuelTypes: [],

            reportFields: [
                { key: "siraNo", name: "S.No", thClass: "text-nowrap", tdClass: "text-nowrap" },
                { key: "transactionDate", name: "Tarih", thClass: "text-nowrap", tdClass: "text-nowrap" },
                { key: "transactionTime", name: "Saat", thClass: "text-nowrap", tdClass: "text-nowrap" },
                { key: "FuelStorageName", name: "Depo", thClass: "text-nowrap", tdClass: "text-nowrap" },
                { key: "StorageClassName", name: "Depo Sınıfı", thClass: "text-nowrap", tdClass: "text-nowrap" },
                { key: "FuelTypeName", name: "Yakıt Tipi", thClass: "text-nowrap", component: true, componentOptions: { name: "fuel-storage/FuelTypeBadge" } },
                { key: "OutputQuantityStr", name: "Toplam [lt]", thClass: "text-nowrap", tdClass: "text-nowrap text-right" },
                { key: "FuelPump1LTStr", name: "Pompa 1 [lt]", thClass: "text-nowrap", tdClass: "text-nowrap text-right" },
                { key: "FuelPump1CounterStr", name: "Pompa 1 Sayaç", thClass: "text-nowrap", tdClass: "text-nowrap text-right" },
                { key: "FuelPump2LTStr", name: "Pompa 2 [lt]", thClass: "text-nowrap", tdClass: "text-nowrap text-right" },
                { key: "FuelPump2CounterStr", name: "Pompa 2 Sayaç", thClass: "text-nowrap", tdClass: "text-nowrap text-right" },
                { key: "Ac1FuelPumpLTStr", name: "Klima 1 [lt]", thClass: "text-nowrap", tdClass: "text-nowrap text-right" },
                { key: "Ac2FuelPumpLTStr", name: "Klima 2 [lt]", thClass: "text-nowrap", tdClass: "text-nowrap text-right" },
                { key: "DriverEmployeeName", name: "Sürücü", thClass: "text-nowrap", tdClass: "text-nowrap" },
                { key: "DriverBranchName", name: "Sürücü Şubesi (İşlem Tarihi)", thClass: "text-nowrap", tdClass: "text-nowrap" },
                { key: "DriverGarageName", name: "Sürücü Görev Yeri (İşlem Tarihi)", thClass: "text-nowrap", tdClass: "text-nowrap" },
                { key: "vehicleDuty", name: "Görev Yeri", thClass: "text-nowrap", tdClass: "text-nowrap" },
                { key: "VehiclePlateValue", name: "Araç Plakası", thClass: "text-nowrap", tdClass: "text-nowrap" },
                { key: "TrailerPlateValue", name: "Treyler Plakası", thClass: "text-nowrap", tdClass: "text-nowrap" },
                { key: "VehicleCurrentKMStr", name: "Araç KM", thClass: "text-nowrap", tdClass: "text-nowrap text-right" },
                { key: "VehicleAcCurrentCounterStr", name: "Araç Klima Sayaç", thClass: "text-nowrap", tdClass: "text-nowrap text-right" },
                { key: "EmployeeFullName", name: "İşlemi Yapan", thClass: "text-nowrap", tdClass: "text-nowrap" },
                { key: "Description", name: "Açıklama", thClass: "text-nowrap", tdClass: "text-nowrap" },
            ],
        };
    },
    created() {
        this.loadFilterOptions();
    },
    watch: {
        reportFilters: {
            handler() {
                clearTimeout(this.filterWatcher);
                this.filterWatcher = setTimeout(() => {
                    this.$refs.reportTable.refresh();
                }, 500);
            },
            deep: true,
        },
    },
    methods: {
        exportToExcel() {
            const table = this.$refs.reportTable;
            const tableData = table?.$data?.d_items || [];

            if (tableData.length === 0) {
                this.$toast.warning("Dışa aktarılacak veri bulunamadı");
                return;
            }

            this.generateExcelFile(tableData);
        },
        generateExcelFile(data) {
            const columns = [
                { label: "S.No", value: "siraNo" },
                { label: "Tarih", value: "transactionDate" },
                { label: "Saat", value: "transactionTime" },
                { label: "Depo", value: "FuelStorageName" },
                { label: "Depo Sınıfı", value: "StorageClassName" },
                { label: "Yakıt Tipi", value: "FuelTypeName" },
                { label: "Toplam [lt]", value: "OutputQuantityStr" },
                { label: "Pompa 1 [lt]", value: "FuelPump1LTStr" },
                { label: "Pompa 1 Sayaç", value: "FuelPump1CounterStr" },
                { label: "Pompa 2 [lt]", value: "FuelPump2LTStr" },
                { label: "Pompa 2 Sayaç", value: "FuelPump2CounterStr" },
                { label: "Klima 1 [lt]", value: "Ac1FuelPumpLTStr" },
                { label: "Klima 2 [lt]", value: "Ac2FuelPumpLTStr" },
                { label: "Sürücü", value: "DriverEmployeeName" },
                { label: "Sürücü Şubesi (İşlem Tarihi)", value: "DriverBranchName" },
                { label: "Sürücü Görev Yeri (İşlem Tarihi)", value: "DriverGarageName" },
                { label: "Araç Plakası", value: "VehiclePlateValue" },
                { label: "Treyler Plakası", value: "TrailerPlateValue" },
                { label: "Araç KM", value: "VehicleCurrentKMStr" },
                { label: "Araç Klima Sayaç", value: "VehicleAcCurrentCounterStr" },
                { label: "Görev Yeri", value: "vehicleDuty" },
                { label: "Açıklama", value: "Description" },
            ];

            const content = data.map((item) => ({
                siraNo: item.siraNo || "-",
                transactionDate: item.transactionDate || "-",
                transactionTime: item.transactionTime || "-",
                FuelStorageName: item.FuelStorageName || "-",
                StorageClassName: item.StorageClassName || "-",
                FuelTypeName: item.FuelTypeName || "-",
                OutputQuantityStr: item.OutputQuantityStr || "0",
                FuelPump1LTStr: item.FuelPump1LTStr || "0",
                FuelPump1CounterStr: item.FuelPump1CounterStr || "0",
                FuelPump2LTStr: item.FuelPump2LTStr || "0",
                FuelPump2CounterStr: item.FuelPump2CounterStr || "0",
                Ac1FuelPumpLTStr: item.Ac1FuelPumpLTStr || "0",
                Ac2FuelPumpLTStr: item.Ac2FuelPumpLTStr || "0",
                DriverEmployeeName: item.DriverEmployeeName || "-",
                DriverBranchName: item.DriverBranchName || "-",
                DriverGarageName: item.DriverGarageName || "-",
                VehiclePlateValue: item.VehiclePlateValue || "-",
                TrailerPlateValue: item.TrailerPlateValue || "-",
                VehicleCurrentKMStr: item.VehicleCurrentKMStr || "0",
                VehicleAcCurrentCounterStr: item.VehicleAcCurrentCounterStr || "0",
                vehicleDuty: item.vehicleDuty || "-",
                Description: item.Description || "-",
            }));

            this.downloadExcel(columns, content);
        },
        downloadExcel(columns, content) {
            const settings = {
                fileName: `Yakit_Cikis_Raporu_${new Date().toISOString().slice(0, 10)}`,
                extraLength: 3,
                writeMode: "writeFile",
            };

            xlsx([{ sheet: "Yakıt Çıkış Raporu", columns, content }], settings);
        },
        loadFilterOptions() {
            this.loadAllEmployees();
            this.loadVehiclePlates();
            this.loadBranches();
            this.loadFuelTypes();
        },
        clearFilters() {
            const initial = getInitialFilters();
            initial.startDate = null;
            initial.endDate = null;
            this.reportFilters = initial;
        },
        fetchDailyReport() {
            const params = {
                ...this.reportFilters,
                startDate: this.reportFilters.startDate ? `${this.reportFilters.startDate}T00:00:00` : null,
                endDate: this.reportFilters.endDate ? `${this.reportFilters.endDate}T23:59:59` : null,
            };
            return api.FuelStorageReport.GetOutputReport(params);
        },
        processReportData(response) {
            if (!response?.Success) {
                this.$result({ data: response });
                this.summaryData = { motorin: { totalOutput: 0, transactionCount: 0 }, adblue: { totalOutput: 0, transactionCount: 0 } };
                return [];
            }

            const data = response.Data || [];
            const summary = {
                motorin: { totalOutput: 0, transactionCount: 0 },
                adblue: { totalOutput: 0, transactionCount: 0 },
            };

            data.forEach((item) => {
                const type = (item.FuelTypeName || "").toLowerCase();
                const quantity = item.OutputQuantity || 0;

                if (type.includes("motorin")) {
                    summary.motorin.totalOutput += quantity;
                    summary.motorin.transactionCount++;
                } else if (type.includes("adblue")) {
                    summary.adblue.totalOutput += quantity;
                    summary.adblue.transactionCount++;
                }
            });
            this.summaryData = summary;

            data.sort((a, b) => new Date(b.TransactionDate) - new Date(a.TransactionDate));

            return data.map((item, index) => {
                const date = new Date(item.TransactionDate);
                return {
                    ...item,
                    siraNo: index + 1,
                    transactionDate: item.TransactionDate ? date.toLocaleDateString("tr-TR") : "-",
                    transactionTime: item.TransactionDate ? date.toLocaleTimeString("tr-TR", { hour: "2-digit", minute: "2-digit" }) : "-",
                    vehicleDuty: [item.VehicleDutyFirm, item.VehicleDutyLocation].filter(Boolean).join(" - "),
                };
            });
        },
        loadAllEmployees() {
            EmployeeOperationsApi.Employee.List().then((res) => {
                if (res.data.Success) this.allEmployees = res.data.Data || [];
            });
        },
        loadVehiclePlates() {
            VehicleOperationsApi.Plate.ListTruck().then((response) => {
                this.vehiclePlateOptions = response.data.Data;
            });
        },
        loadBranches() {
            CompanyApi.Branch.ListByCode("O").then((res) => {
                if (res.data.Success) this.branches = res.data.Data || [];
            });
        },
        loadFuelTypes() {
            SystemDataApi.FuelType(true).then((res) => {
                if (res.data.Success) this.fuelTypes = res.data.Data || [];
            });
        },
    },
};
</script>
<style>
.stats-group {
    border: 1px solid #e9ecef;
    border-left-width: 4px;
    border-radius: 6px;
    padding: 1rem;
}
.stats-group.motorin {
    border-left-color: #ffc107;
}
.stats-group.adblue {
    border-left-color: #0d6efd;
}
.stats-group-title {
    color: #6c757d;
    font-size: 0.9rem;
    font-weight: 600;
    margin-top: -0.25rem;
    margin-bottom: 0.75rem;
}
</style>
